<template>
  <a-modal v-bind:open="this.showModal"
           width="1600px"
           :closable="true"
           :footer="null"
           :mask-closable="false"
           :mask-style="{backdropFilter: 'blur(2px)'}"
           :keyboard="false"
           @cancel="uiHandler.closeModal"
           class="contract-draft-modal"
           :style="`top:${modalTop}px`"
  >
    <div>
      <iframe :src=this.embeddedUrl style="margin-top: 60px; width:100%;  border:none;" :style="`height:${windowInnerHeight}px`"></iframe>
    </div>
  </a-modal>
</template>
<script>

const readOnly = {
  event: {
    CloseModal: "CloseModal"
  },
}

export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false
    },
    embeddedUrl: {
      type: String,
      required: true,
      default: false
    },
  },
  data() {
    return {
      uiHandler: this.ui(),
      windowInnerHeight:1000,
      modalTop:20
    }
  },
  mounted(){
    this.windowInnerHeight = window.innerHeight-window.innerHeight/5;
    this.modalTop = (window.innerHeight-this.windowInnerHeight)/4;
  },
  methods: {
    ui() {
      return {
        closeModal: () => {
          this.$emit(readOnly.event.CloseModal, {
            ModalStatus: false
          });
        }
      }
    }
  }
}
</script>
<style lang="scss">
.contract-draft-modal.ant-modal{
  padding-bottom: 0!important;
}
</style>